import { AnyObject } from '@hb/shared'

import arrayMutators from 'final-form-arrays'
import { Form } from 'react-final-form'
import { FormWidthProvider } from './context'
import { FormProvider, FormProviderOnSave } from './FormProvider'
import { FormRegistrar } from './FormRegistrar'
import { useDecorators } from './hooks/useDecorators'
import { useFormSubmit } from './hooks/useFormSubmit'
import { useFormValidate } from './hooks/useFormValidate'
import { NavigationGuard } from './NavigationGuard'
import { InnerFormProps } from './types'

const emptySubscription = {}
export const InnerForm = <T extends AnyObject>({
  children,
  data,
  onSubmit,
  field,
  closeOnSuccess,
  onClose,
  setUploads,
  boxProps,
  warnNavigationIfDirty,
  registerForm,
  validate: customValidate,
}: InnerFormProps<T>) => {
  const validate = useFormValidate(field, customValidate)
  const { submit, onFormSubmit } = useFormSubmit(
    field,
    onSubmit,
    setUploads,
    closeOnSuccess,
    onClose,
  )
  const decorators = useDecorators<T>(field)

  return (
    <FormWidthProvider {...boxProps}>
      <Form<T>
        mutators={{ ...arrayMutators }}
        initialValues={data as T}
        validate={validate}
        decorators={decorators}
        onSubmit={onFormSubmit}
        subscription={emptySubscription}>
        {props => (
          <form onSubmit={props.handleSubmit} style={{ display: 'contents' }}>
            <FormProvider onSave={submit as FormProviderOnSave<AnyObject>}>
              {warnNavigationIfDirty ? (
                <NavigationGuard formName={warnNavigationIfDirty.formName} />
              ) : null}
              {registerForm ? <FormRegistrar registerForm={registerForm} field={field} /> : null}
              {typeof children === 'function' ? children(props) : children}
            </FormProvider>
          </form>
        )}
      </Form>
    </FormWidthProvider>
  )
}
